const AUTH_PATH = "/auth";
const UPLOAD_FILE_PATH = "/api/FileUpload";
const SEO_PATH = "/Seo";
const BLOG_PATH = "/Blog";
const BLOGFOOTER_PATH = "/BlogFooter";
const PAGE_PATH = "/Page";
const SETTING_PATH = "/Setting";
const FAQ_PATH = "/Faq";
const TONE_PATH = "/TranslationTone";
const SiteMap_PATH = "/SiteMap";
const Translate_PATH = "/translate";
const VISIT_PATH = "/visit";
const Transaction = "/Transaction";
const USER_PATH = "/user";
const AUTH = {
  LOGIN_WITH_GOOLE_GMAIL: {
    url: `${AUTH_PATH}/login`,
  },
  LOGIN_WITH_GMAIL: {
    url: `${AUTH_PATH}/LoginWithEmail`,
  },
  Admin_LOGIN_WITH_GMAIL: {
    url: `${AUTH_PATH}/adminlogin`,
  },
  CREATE: {
    url: `${Translate_PATH}/Create`,
  },
  PdfCreate: {
    url: `${Translate_PATH}/PdfCreate`,
  },
  CREATESUCCESS: {
    url: `${Translate_PATH}/CreateSuccess`,
  },
  DELETEFILE: {
    url: `${Translate_PATH}/delete`,
  },
  GetFilePreview: {
    url: `${Translate_PATH}/GetFilePreview`,
  },
};

const PAYMENT = {
  GetPageHistoryTransactionByUser: {
    url: `/GetPageHistoryTransactionByUser`,
  },
  GetHistoryTranslate: {
    url: `/GetHistoryTranslate`,
  },

  GetFileHistoryTranslate: {
    url: `/GetFileHistoryTranslate`,
  },
  GetPaymentQrCode: {
    url: `/GetPaymentQrCode`,
  },
};

const UPLOAD_FILE = {
  CREATE: {
    url: `${UPLOAD_FILE_PATH}/Upload`,
  },
  DELETE: {
    url: `${UPLOAD_FILE_PATH}/DeleteFile`,
  },
  DELETE_MUlTIPLE: {
    url: `${UPLOAD_FILE_PATH}/DeleteFileMultiple`,
  },
  DOWNLOAD: {
    url: `${UPLOAD_FILE_PATH}/DownloadFile`,
  },
};

const SEO = {
  GetCommonPageSeo: {
    url: `${SEO_PATH}/GetCommonPageSeo`,
  },
  GetCommonBlogSeo: {
    url: `${SEO_PATH}/GetCommonBlogSeo`,
  },
  Update_Content: {
    url: `${SEO_PATH}/UpdateContent`,
  },
  Get_Seo: {
    url: `${SEO_PATH}/GetSeoByObjId`,
  },
  Create_Seo: {
    url: `${SEO_PATH}/Create`,
  },
  Update_Seo: {
    url: `${SEO_PATH}/Update`,
  },
};

const BLOG = {
  UserGetPage: {
    url: `${BLOG_PATH}/UserGetPage`,
  },
  AdminGetPage: {
    url: `${BLOG_PATH}/AdminGetPage`,
  },
  GetSingleBySlug: {
    url: `${BLOG_PATH}/GetSingleBySlug`,
  },
  GetSingle: {
    url: `${BLOG_PATH}/GetSingle`,
  },
  Create: {
    url: `${BLOG_PATH}/Create`,
  },
  Update: {
    url: `${BLOG_PATH}/Update`,
  },
  Delete: {
    url: `${BLOG_PATH}/Delete`,
  },
  Sitemap: {
    url: `${BLOG_PATH}/GenerateSitemap`,
  },
};

const BLOGFOOTER = {
  UserGetPage: {
    url: `${BLOGFOOTER_PATH}/UserGetPage`,
  },
  AdminGetPage: {
    url: `${BLOGFOOTER_PATH}/AdminGetPage`,
  },
  GetSingleBySlug: {
    url: `${BLOGFOOTER_PATH}/GetSingleBySlug`,
  },
  GetSingle: {
    url: `${BLOGFOOTER_PATH}/GetSingle`,
  },
  Create: {
    url: `${BLOGFOOTER_PATH}/Create`,
  },
  Update: {
    url: `${BLOGFOOTER_PATH}/Update`,
  },
  Delete: {
    url: `${BLOGFOOTER_PATH}/Delete`,
  },
  Sitemap: {
    url: `${BLOG_PATH}/GenerateSitemap`,
  },
};

const PAGE = {
  GetPage: {
    url: `${PAGE_PATH}/GetPage`,
  },
  GetSingle: {
    url: `${PAGE_PATH}/GetSingle`,
  },
  Create: {
    url: `${PAGE_PATH}/Create`,
  },
  Update: {
    url: `${PAGE_PATH}/Update`,
  },
  Delete: {
    url: `${PAGE_PATH}/Delete`,
  },
};

const Setting = {
  GetSingle: {
    url: `${SETTING_PATH}/GetSingle`,
  },
  CreateOrUpdate: {
    url: `${SETTING_PATH}/CreateOrUpdate`,
  },
};

const FAQ = {
  GetAll: {
    url: `${FAQ_PATH}/GetAll`,
  },
  GetSingle: {
    url: `${FAQ_PATH}/GetSingleByObjId`,
  },
  CreateOrUpdate: {
    url: `${FAQ_PATH}/CreateOrUpdate`,
  },
};

const Tone = {
  GetAll: {
    url: `${TONE_PATH}/GetAll`,
  },
  CreateOrUpdate: {
    url: `${TONE_PATH}/CreateOrUpdate`,
  },
};

const SiteMap = {
  Get: {
    url: `${SiteMap_PATH}/GenerateSitemap`,
  },
};

const VISIT = {
  GetStatistics: {
    url: `${VISIT_PATH}/GetStatistics`,
  },
  GetUserOnline: {
    url: `${VISIT_PATH}/GetUserOnline`,
  },
  GetDeviceStatistics: {
    url: `${VISIT_PATH}/GetDeviceStatistics`,
  },
  Create: {
    url: `${VISIT_PATH}/Create`,
  },
  GetGetCountryCode: {
    url: `${VISIT_PATH}/GetCountryCode`,
  },
};

const USER = {
  GetPage: {
    url: `${USER_PATH}/GetPage`,
  },
  GetPageFileByUserId: {
    url: `${USER_PATH}/GetPageFileByUserId`,
  },
  GetPageFile: {
    url: `${USER_PATH}/GetPageFile`,
  },
};

const ApiEndpoints = {
  AUTH,
  UPLOAD_FILE,
  PAYMENT,
  SEO,
  BLOG,
  BLOGFOOTER,
  VISIT,
  PAGE,
  Setting,
  FAQ,
  Tone,
  SiteMap,
  USER,
};

export default ApiEndpoints;
